import(/* webpackMode: "eager", webpackExports: ["QuizPlayer"] */ "/opt/buildhome/repo/apps/web/components/quiz/quiz-player.tsx");
